import { Component } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { Router, ActivatedRoute } from "@angular/router";
import {
  LEVEL_PUBLISHED,
  PARAM_NEWS_PATH,
  STATUS_TYPE_LIST,
} from "src/app/admin/constants/constants";
import { AbstractListController } from "../../common/abstract-list.component";
import { NewsService } from "src/app/services/news.service";
import { News } from "src/app/models/news";
import { environment } from "src/environments/environment";
import { CommonModule } from "@angular/common";
import { ToastModule } from "primeng/toast";
import { DataTableComponent } from "../../common/data-table/data-table.component";
import {
  RowAction,
  TableColumn,
  TableFilter,
} from "../../common/data-table/data-table.model";

@Component({
  standalone: true,
  selector: "app-manage-news",
  templateUrl: "./manage-news.component.html",
  imports: [CommonModule, ToastModule, DataTableComponent],
})
export class ManageNewsComponent extends AbstractListController<News, any> {
  title = "News";

  tableColumns: TableColumn[] = [
    {
      field: "level",
      header: "News",
      type: "tag",
      tagMap: {
        2: { label: "High", severity: "success" },
        1: { label: "Medium", severity: "success" },
        0: { label: "Low", severity: "danger" },
      },
    },
    { field: "page_title", header: "Titolo" },
    {
      field: "is_active",
      header: "Attivo",
      type: "boolean",
      trueTag: { label: "SI", severity: "success" },
      falseTag: { label: "NO", severity: "danger" },
    },
  ];

  tableFilters: TableFilter[] = [
    {
      field: "level",
      header: "Level",
      type: "select",
      options: LEVEL_PUBLISHED,
    },
    { field: "page_title", header: "Titolo", type: "string" },
    {
      field: "is_active",
      header: "Attivo",
      type: "select",
      options: STATUS_TYPE_LIST,
    },
  ];

  rowActions: RowAction[] = [
    {
      icon: "pi pi-copy",
      tooltip: "Copia link",
      styleClass: "p-button p-button-options",
      event: "copyLink",
    },
  ];

  editLink = (row: News): any[] => ["/admin/news/edit", row.id];

  constructor(
    private newsService: NewsService,
    protected confirmationService: ConfirmationService,
    router: Router,
    private messageService: MessageService,
    route: ActivatedRoute,
  ) {
    super(newsService, confirmationService, router, route, PARAM_NEWS_PATH);
    this.useTableFilters = true;
  }

  onAction(e: { event: string; row: News }): void {
    if (e.event === "copyLink") {
      this.copyLink(e.row.page_url);
    }
  }

  copyLink(link: string) {
    navigator.clipboard
      .writeText(environment.blog_url + link)
      .then(() => {
        this.messageService.add({
          severity: "success",
          summary: "Copiato!",
          detail: "Il link è stato copiato negli appunti",
          life: 2000,
        });
      })
      .catch((err) => {
        this.messageService.add({
          severity: "error",
          summary: "Errore",
          detail: "Non è stato possibile copiare il link",
        });
        console.error("Clipboard error:", err);
      });
  }
}
